export default __webpack_public_path__ + "static/media/adobe-stock-204554418-preview@2x.21443bcd.png";